import { TranslateResult } from 'vue-i18n';

// Made them matching the titleListName enum from /src/interfaces/responses/title-list.ts
// See TVN-#150 (https://trello.com/c/um85g7Ku/150-quick-action-issue-web)
// Needs refactor
export enum TabType {
	WATCH_NEXT = 'watchlist',
	COMPLETED_SEEN = 'seenlist',
	LIKE = 'likelist',
	DISLIKE = 'dislikelist',
}

export const tabTypeMigrationMap = {
	watch_now: 'watchlist',
	seen: 'seenlist',
	like: 'likelist',
	dislike: 'dislikelist',
};

export interface InnerTab {
	text: string | TranslateResult;
	filterName: string;
	type: TabType;
	active: boolean;
	badge?: number;
	icon?: string;
	onClick?: (item: InnerTab) => void;
}
